export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12836.94cd0102.jpg";